import { Box, IconButton, Typography } from "@mui/material";
import React, { useContext } from "react";
import SHFormTextField from "../form/SHFormTextField";
import { SearchOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { SearchContext } from "../../context/SearchContextProvider";
import { BoxProps, styled } from "@mui/system";
import { useWatch } from "react-hook-form";



const StyledSearchTerm = styled(Box)<BoxProps>(({theme}) => ({
    background: theme?.palette?.primary?.light,
    borderRadius: '0.3em',
    padding: '0.5em',
    margin: '0 0.5em'
}));

interface Props {

}

const SearchForm : React.FC<Props> = () => {
    const SEARCH_FIELD_NAME = "search";
    const {searchTerms, addSearchTerms} = useContext(SearchContext);
    const {t} = useTranslation("common");
    const watchSearch = useWatch({name: SEARCH_FIELD_NAME});

    if(watchSearch?.length > 0 && watchSearch?.endsWith(" ")) {
        const currentSearchTerms =(watchSearch.split(" ") as string[]).filter(t => t?.length > 0);
        if(searchTerms?.length !== currentSearchTerms?.length) {
            addSearchTerms(currentSearchTerms);
        }
    }
    else if(watchSearch === "" && searchTerms?.length > 0) {
        addSearchTerms([]);
    }

    return <>
        <Box sx={{display: 'flex', justifyContent: "center", alignItems: "center"}}>
            <Box>
                <SHFormTextField name={SEARCH_FIELD_NAME} label={t("common.search")} />
            </Box>
            <Box>
            <IconButton type="submit">
                <SearchOutlined />
            </IconButton>
            </Box>
        </Box>
        
        <Box sx={{display: 'flex', justifyContent: 'left'}}>
            {searchTerms?.map(searchTerm => <StyledSearchTerm>
                    <Box sx={{display: 'flex', justifyContent: "space-between"}}>
                        <Typography variant="body2">{searchTerm}</Typography>
                    </Box>
                </StyledSearchTerm>)}
        </Box>
    </>
}

export default SearchForm;